const ROOT_PATH = '/classifications';

export const ClassificationsPaths = {
  ROOT_PATH,
} as const;
